import React, { useMemo } from "react";

import { useDropzone } from "react-dropzone";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "1rem",
  borderWidth: 2,
  borderRadius: "0.25rem",
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  minHeight: "10rem",
  transition: ".24s ease-in-out"
};

const activeStyle = {
  color: "var(--info)",
  backgroundColor: "#3399ff2f",
  borderColor: "var(--info)"
};

const rejectStyle = {
  color: "var(--danger)",
  backgroundColor: "#e553532f",
  borderColor: "var(--danger)"
};

const DropzoneComponent = props => {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
    isFileDialogActive
  } = useDropzone({ onDrop: props.onDrop });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isFileDialogActive ? activeStyle : {}),
      ...(isDragAccept ? activeStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isFileDialogActive, isDragActive, isDragReject, isDragAccept]
  );

  const files = acceptedFiles.map(file => (
    <li
      key={file.path}
      className="list-group-item d-flex justify-content-between align-items-center"
    >
      {file.path}
      <span className="badge badge-primary badge-pill">
        {file.size < 1024 ? "< 1" : parseInt(file.size / 1024)} KB
      </span>
    </li>
  ));

  return (
    <section>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <span style={{ pointerEvents: "none" }}>
          Arraste os arquivos para cá, ou clique para selecionar
        </span>
      </div>
      <aside className="mt-3">
        <strong>Arquivos selecionados</strong>
        <ul
          className="list-group mt-2"
          style={{ maxHeight: "10rem", overflow: "auto" }}
        >
          {files}
        </ul>
      </aside>
    </section>
  );
};

export default DropzoneComponent;
